import * as React from "react";

function google(props) {
  return (
    <svg viewBox="0 0 31 31" fill="none" {...props}>
      <path
        d="M7.183 15.322a8.09 8.09 0 011.145-4.158V5.998H3.162A15.207 15.207 0 000 15.322c0 3.417 1.111 6.662 3.162 9.325h5.166V19.48a8.09 8.09 0 01-1.145-4.159z"
        fill="#FBBD00"
      />
      <path
        d="M15.322 23.462l-3.591 3.591 3.59 3.591c3.417 0 6.662-1.111 9.325-3.161v-5.16h-5.16a8.14 8.14 0 01-4.164 1.139z"
        fill="#0F9D58"
      />
      <path
        d="M8.33 19.481l-5.166 5.166c.406.527.848 1.032 1.326 1.51a15.223 15.223 0 0010.835 4.489v-7.183c-2.97 0-5.573-1.6-6.995-3.982z"
        fill="#31AA52"
      />
      <path
        d="M30.643 15.323c0-.932-.084-1.866-.25-2.775l-.136-.736H15.32v7.182h7.27a8.103 8.103 0 01-3.106 3.33l5.16 5.16a15.569 15.569 0 001.511-1.326 15.223 15.223 0 004.488-10.835z"
        fill="#3C79E6"
      />
      <path
        d="M21.078 9.567l.634.634 5.08-5.078-.636-.635A15.222 15.222 0 0015.323 0L11.73 3.591l3.59 3.592c2.175 0 4.22.846 5.757 2.384z"
        fill="#CF2D48"
      />
      <path
        d="M15.325 7.183V0C11.232 0 7.385 1.594 4.49 4.488c-.478.478-.92.983-1.326 1.51l5.166 5.166a8.144 8.144 0 016.995-3.981z"
        fill="#EB4132"
      />
    </svg>
  );
}

const Memogoogle = React.memo(google);
export default Memogoogle;
